
 <ngx-one-column-layout class="account-layout"  *ngIf="loaded; loader">
      <nb-menu  [autoCollapse]="true" [items]="menu"></nb-menu>


      <router-outlet></router-outlet>
    
    </ngx-one-column-layout>

    

 
   <ng-template #loader>
      <div style="position: fixed; z-index: 777; width:100%; height:100%; top:0; left: 0; display: flex; align-self: center;">
      <div style="margin: auto;"> 
           <app-loader></app-loader>
       </div>
      </div>
  </ng-template> 
  

